/**
 * API URL resolver for VisualGrid.
 *
 * In the web app (Next.js server running), API routes are relative: `/api/...`
 * In the Tauri desktop app (static export, no server), API routes must be
 * proxied to the production server defined by NEXT_PUBLIC_API_URL.
 *
 * Usage:
 *   fetch(getApiUrl('/api/synoptic/projects'), { ... })
 */

import { isTauriApp } from './tauri-auth';

/** Base URL for API calls — only set in Tauri builds via .env.tauri */
const API_BASE_URL: string = process.env.NEXT_PUBLIC_API_URL || '';

/** Fallback production URL when NEXT_PUBLIC_API_URL is not configured */
const PRODUCTION_URL = 'https://visualgrid.app';

/**
 * Resolve an API path to a full URL.
 * - Tauri: `https://visualgrid.app/api/...` (via NEXT_PUBLIC_API_URL or fallback)
 * - Web:   `/api/...` (relative, handled by Next.js server)
 */
export function getApiUrl(path: string): string {
  const isTauri = isTauriApp();
  const isLocalDev = typeof window !== 'undefined'
    && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (!isTauri || isLocalDev) {
    return path;
  }

  const baseUrl = API_BASE_URL || PRODUCTION_URL;
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
}
